import { MenuItem } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useCancelSession } from 'features/sessions/hooks/useCancelSession';

type SessionsTableMoreOptionsCancelMenuItemProps = {
  sessionId: string;
  options?: any;
};

export const SessionsTableMoreOptionsCancelMenuItem = ({
  sessionId,
  options,
}: SessionsTableMoreOptionsCancelMenuItemProps) => {
  const { handleCancelModalOpen } = useCancelSession(sessionId, options);

  return (
    <MenuItem
      onClick={(evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
        handleCancelModalOpen();
      }}
    >
      <Icon
        name={iconNames.cancelCircle}
        fill="var(--fgPrimary)"
        width="16px"
        height="16px"
      />{' '}
      Cancel
    </MenuItem>
  );
};
